<template>
  <div>
    <wc-data-box
      :loading='loading || isLoading'
      :title='title'
      :titleIcon='$store.state.icons.modules.clients.icon'
      :titleIconColor='$store.state.icons.modules.clients.color'
      :showEdit='!estimate.is_sold'
      @edit='editContacts'
    >
      <v-simple-table dense>
        <tbody>
          <tr v-for='(c, index) in contactsData' :key='index'>
            <td :class='label'>{{ c.label }}</td>
            <td :class='dataValue' v-if='c.data'>
              {{ c.data.name_display }}
              <v-btn icon small @click="contactCard(c.data, c.label)">
                <v-icon color='grey'>{{ contactIcon }}</v-icon>
              </v-btn>
            </td>
            <td :class='dataValue' v-else>Not set</td>
          </tr>
        </tbody>
      </v-simple-table>
    </wc-data-box>

    <wc-contact-card
      :contact='contact'
      :showDialog='showCard'
      @close='showCard = false'
    ></wc-contact-card>

    <wc-dialog
      :showDialog='showEditContacts'
      :loading='isLoading'
      :title='title'
      :icon='$store.state.icons.modules.clients.icon'
      :disableButtons='!isContactFormValid || isLoading'
      @cancel='cancelEditContacts'
      @save='checkEstimateName'
      width='400'
      :fullscreen='$vuetify.breakpoint.xs'
    >
      <v-form v-model='isContactFormValid'>
        <contacts-form
          :contacts='contacts'
          v-model='estimateCopy'
        ></contacts-form>
      </v-form>
      <template v-slot:dialog-actions>
        <v-btn text small color='success' @click='addContact'>
          <v-icon left>mdi-plus</v-icon>
          Create Client
        </v-btn>
      </template>
    </wc-dialog>

    <wc-dialog
      :showDialog='showChangeEstimateName'
      title='Change Estimate Name?'
      icon='mdi-alert'
      @cancel='update'
      @save='changeEstimateName'
      width='350'
      cancelText='No'
      saveText='Yes'
    >
      It looks like the owner has been changed. Do you want to update the estimate name to
      reflect the last name of the new owner?
    </wc-dialog>

    <wc-quick-create-client
      ref='quickCreateDialog'
      :showQuickCreate='showQuickCreate'
      @cancel='showQuickCreate = false'
      @save='saveQuickCreate'
    ></wc-quick-create-client>
  </div>
</template>

<script>
import _ from 'lodash'
import clients from '@/modules/clients/api/clients'
import ContactsForm from '@/modules/estimates/components/forms/ContactsForm'
import WCQuickCreateClient from '@/components/clients/WCQuickCreateClient'
import WCContactCardDialog from '@/components/dialogs/WCContactCardDialog'

export default {
  name: 'estimate-contacts',
  props: {
    estimate: {
      required: true
    },
    loading: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    contacts: [],
    showCard: false,
    showEditContacts: false,
    showQuickCreate: false,
    showChangeEstimateName: false,
    contactIcon: 'mdi-account-circle',
    isContactFormValid: false,
    title: 'Contacts',
    label: 'grey--text',
    dataValue: 'text-right pr-2',
    contact: [],
    estimateCopy: {}
  }),
  computed: {
    contactsData () {
      let data = []
      data.push({ label: 'Owner', data: this.estimate.owner ? this.estimate.owner_obj : null })
      data.push({ label: 'Billing Contact', data: this.estimate.bill_to ? this.estimate.bill_to_obj : null })
      data.push({ label: 'Sales Contact', data: this.estimate.sales_contact ? this.estimate.sales_contact_obj : null })
      if (this.estimate.division_obj.division === 'Irrigation') {
        data.push({ label: 'Notices Contact', data: this.estimate.notices_contact ? this.estimate.notices_contact_obj : null })
        data.push({ label: 'Install Contact', data: this.estimate.install_contact ? this.estimate.install_contact_obj : null })
        data.push({ label: 'Service Contact', data: this.estimate.site_contact ? this.estimate.site_contact_obj : null })
        data.push({ label: 'Secondary Service Contact', data: this.estimate.secondary_site_contact ? this.estimate.secondary_site_contact_obj : null })
      } else {
        data.push({ label: 'Site Contact', data: this.estimate.site_contact ? this.estimate.site_contact_obj : null })
      }
      return data
    }
  },
  watch : {
    showEditContacts() {
      if (this.showEditContacts && !this.contacts.length) {
        this.getContacts()
      }
    }
  },
  methods: {
    async getContacts () {
      this.isLoading = true
      this.contacts = await clients.getContactsAndClients()
      this.contacts = _.orderBy(this.contacts, 'name_display')
      this.isLoading = false
    },
    contactCard (cont, contType) {
      this.contact = _.cloneDeep(cont)
      this.contact.contact_type = contType
      this.showCard = true
    },
    closeCard () {
      this.showCard = false
    },
    addContact () {
      this.showQuickCreate = true
      this.$refs.quickCreateDialog.resetForm()
    },
    async saveQuickCreate (newClient) {
      this.contacts.push(newClient)
      this.contacts = _.orderBy(this.contacts, 'name_display')
      this.showQuickCreate = false
    },
    editContacts () {
      this.estimateCopy = _.cloneDeep(this.estimate)
      this.showEditContacts = true
    },
    cancelEditContacts () {
      this.showEditContacts = false
    },
    update () {
      this.$emit('update', this.estimateCopy)
      this.showChangeEstimateName = false
      this.showEditContacts = false
    },
    changeEstimateName () {
      const cont = this.contacts.find(c => c.id === this.estimateCopy.owner)
      this.estimateCopy.name = cont.last_name
      this.update()
    },
    checkEstimateName () {
      if (this.estimate.owner !== this.estimateCopy.owner) {
        this.showChangeEstimateName = true
      } else {
        this.update()
      }
    }
  },
  components: {
    'contacts-form': ContactsForm,
    'wc-quick-create-client': WCQuickCreateClient,
    'wc-contact-card': WCContactCardDialog
  }
}
</script>
